export function getLastUserMessage(history) {
    return history.filter(msg => msg.role === 'user').pop();
}
  
export function updateMessageInHistory(history, index, newContent) {
    const updated = [...history];
    updated[index] = { ...updated[index], ...newContent };
    return updated;
}

// Function to get the index of the last message with a specific role
export const getLastMessageIndexByRole = (chatHistory, role) => {
    const MessagesWithIndex = chatHistory
      .map((message, index) => ({ ...message, index })) // Pair each message with its index
      .filter(message => message.role === role);
  
    if (MessagesWithIndex.length > 0) {
      return MessagesWithIndex[MessagesWithIndex.length - 1].index; // Get the index of the last message of the given role
    }
  
    return -1; // Return -1 if no message of the given role is found
  };
  
// Function to scroll to the last conversation item
export const scrollToLastConversationItem = () => {
  const container = document.querySelector('.container');
  if (!container) {
    // console.log('scrollToLastConversationItem: container is null or undefined');
    return;
  }
  // console.log('scrollToLastConversationItem: container found');

  const items = container.querySelectorAll('.conversation-item');
  // console.log('scrollToLastConversationItem: found', items.length, 'conversation items');

  if (!items.length) {
    // console.log('scrollToLastConversationItem: no conversation items found');
    return;
  }

  const lastItem = items[items.length - 1];
  // console.log('scrollToLastConversationItem: scrolling to last item', lastItem);

  lastItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
  // console.log('scrollToLastConversationItem: scrollIntoView called');
  setTimeout(() => {
    container.scrollTop += 160;
  }, 200);
};